<template>
  <div class="p-grid">
    <div class="p-col-12">
      <div class="card card-w-title">
        <div class="manager-title">{{ title }}</div>
        <BaseDatatable
          :key="componentKey"
          :tableData="listData"
          :model="dataModel"
          :options="options"
          :getFilterOptions="getFilterOptions"
          :actions="getRowActions()"
          v-on:action-click="onActionClicked"
          @dataQuery="UpdateFilter"
          @dataFilterQuery="dataFilterQuery"
          :data_filter="data_Filter"
          :data_filterCus="data_FilterCus"
          @onDataChange = 'DataOnChange'
        ></BaseDatatable>
        <Dialog
          style=""
          header="Delete"
          :visible.sync="showDeleteDialog"
          :contentStyle="{overflow: 'visible'}"
          :modal="true"
        >
          Are you sure you want to delete?
          <template
            #footer
          >
            <Button label="Delete" @click="deleteData()" icon="pi pi-check" class="p-button-danger" />
            <Button
              label="Hủy"
              @click="showDeleteDialog = false"
              icon="pi pi-times"
              class="p-button-warning"
            />
          </template>
        </Dialog>
      </div>
    </div>
  </div>
</template>

<script>
import DataServices from '@/core/DataServices'
import BaseDatatable from './list'
export default {
  components: {
    BaseDatatable,
  },
  data() {
    return {
      filterOptions: {},
      options: [],
      listData: [],
      modelName: '',
      dataModel: null,
      title: '',
      componentKey: 0,
      page_transaction:null,
      editId: null,
      displayDialog: false,
      editDialogKey: 0,
      dialogMode: 'edit',
      deleteId: null,
      deleteName: null,
      showDeleteDialog: false,
      dataDelete :{},
      role: {
        view: false,
        add: false,
        edit: false,
        delete: false,
      },
      data_FilterCus : [],
      data_Filter : {},
      country_id : null,
      province_id : null,
      district_id : null,
      ward_id : null,
    }
  },
  mounted () {
    this.initParams();
  },
  async created() {
    this.modelName = this.$route.meta.model;
    this.dataModel = DataServices.getModel(this.modelName);
    //console.log('this.dataModel:',this.dataModel);
    this.title = this.dataModel.name
    this.$store.commit('setLoading', true);
    if(this.$route.params.reload) {
      window.location.reload();
    }
    var arr_role = await this.$CoreService.checkPermission(this.$constants.KEY_MENU.LIST_STADIUM);
    if (arr_role.indexOf(this.$constants.ROLE.VIEW) < 0){
      this.$router.push({path: this.$constants.URL_ERR.FOBIDDEN});
    }
    this.role.add = (arr_role.indexOf(this.$constants.ROLE.ADD) < 0) ? false:true;
    this.role.edit = (arr_role.indexOf(this.$constants.ROLE.EDIT) < 0) ? false:true;
    this.role.delete = (arr_role.indexOf(this.$constants.ROLE.DELETE) < 0) ? false:true;
  },
  watch: {
    '$route': 'initParams'
  },
  methods: {
    initParams() {
      this.$store.commit('setLoading', true);
      this.modelName = this.$route.meta.model;
      this.dataModel = DataServices.getModel(this.modelName);
      this.title = this.dataModel.label;
      this.callbackOptions();
    },
    UpdateFilter(params){
      // console.log("params",params);
      this.dataFilter = params;
    },
    dataFilterQuery(data,key,filters){
      console.log("filtersfilters",filters)
      var fil = data
      var tmp = filters
      // console.log("tmptmptmp",tmp)
      if(key == 'name_country'){
        this.country_id = data.name_country ? data.name_country : null
        delete fil['name_province'];
        delete tmp['name_province'];
        delete fil['name_district'];
        delete tmp['name_district'];
        delete fil['name_ward'];
        delete tmp['name_ward'];
        this.province_id = null
        this.district_id = null
        this.ward_id = null
      }else if(key == 'name_province'){
        this.province_id = data.name_province ? data.name_province : null
        delete fil['name_district'];
        delete tmp['name_district'];
        delete fil['name_ward'];
        delete tmp['name_ward'];
        this.district_id = null
        this.ward_id = null
      }else if(key == 'name_district'){
        this.district_id = data.name_district ? data.name_district : null
        delete fil['name_ward'];
        delete tmp['name_ward'];
        this.ward_id = null
      }
      this.data_Filter = fil
      this.data_FilterCus = tmp
      this.callbackOptions();
    },
    onChange() {
      this.$store.commit('setLoading', true);
      this.$apollo.queries.listData.refresh()
    },
    DataOnChange(data,f){
      if(f.type == 'Checkbox'){
        let dataUpdate = {}
        if(f.key == 'active'){
          dataUpdate['active'] = data[f.key]
        }
        let variables = {
          'data_update': dataUpdate,
          'where_key': {
            'id': {'_eq': data.id}
          }
        };
        this.$apollo.mutate({
          mutation: DataServices.updateData(this.modelName),
          variables: variables
        }).then(() => {})
      }
    },
    getFilterOptions(name) {
      var field = this.dataModel.getField(name)
      // console.log("field",field)
      var result = []
      if (field.type == 'Selection') {
        if (field.options ) result = field.options;
        else if(field.models && this.options[name]) result = this.options[name];
      } else {
        result = this.filterOptions[name] != null ? [...this.filterOptions[name]] : []
      }
      // console.log("result",result)
      return result;
    },
    getRowActions() {
      var actions = {}
      var that = this;
      if (this.role.add) {
        actions.header = {name: 'add', icon: 'plus', path: `list-${this.modelName}/add`};
      }
      // actions.header = { name: 'add', icon: 'plus'};
      actions.rows = function (rowData) {
        var buttons = {}
        //buttons.view = { name: 'view', icon: 'eye', key: 'id', path: `list-${that.modelName}/view/`};
        if (that.role.edit) {
          buttons.edit = {name: 'edit', icon: 'pencil', key: 'id', path: `list-${that.modelName}/edit/`};
        }
        if (that.role.delete) {
          buttons.delete = {name: 'delete', icon: 'trash', key: 'id'}
        }
        if (that.dataModel.actions) {
          var modelaction = that.dataModel.actions(rowData)
          Object.assign(buttons, modelaction);
        }
        return buttons
      }
      return actions
    },
    async callbackOptions() {
      var fields = this.dataModel.getDisplayFields();
      var attributes = [];
      for (let index = 0; index < fields.length; index++) {
        const element = fields[index];
        if (element.models !== undefined && element.models !== null) {
          var optionsData = [];
          if(element['name']== "name_country"){
            let where_1 = {
              deleted : {_eq : false}
            }
            let {data} = await this.$apollo.query({
              query: DataServices.getList('country', {"fields" : `id country_lang(where: {lang: {_eq: "en"}}){lang name}`}),
              variables: {
                where_key : where_1,
                orderBy:{ordinal : 'asc'}
              }
            })
            if (data) {
              let result_1 = data[Object.keys(data)];
              if (result_1) {
                for (let index = 0; index < result_1.length; index++) {
                  let ele1 = result_1[index];
                  optionsData.push({value: ele1.id, label: ele1.country_lang[0].name})
                }
              }
            }
          }else if(element['name']== "name_province"){
            if(this.country_id){
              let where_1 = {
                deleted : {_eq : false},
                country_id : {_eq : this.country_id}
              }
              let {data} = await this.$apollo.query({
                query: DataServices.getList('province', {"fields" : `id province_lang(where: {lang: {_eq: "en"}}){lang name}`}),
                variables: {
                  where_key : where_1,
                  orderBy:{ordinal : 'desc'}
                }
              })
              if (data) {
                let result_1 = data[Object.keys(data)];
                if (result_1) {
                  for (let index = 0; index < result_1.length; index++) {
                    let ele1 = result_1[index];
                    optionsData.push({value: ele1.id, label: ele1.province_lang[0].name})
                  }
                }
              }
            }
          }else if(element['name']== "name_district"){
            if(this.province_id){
              let where_1 = {
                deleted : {_eq : false},
                province_id : {_eq : this.province_id}
              }
              let {data} = await this.$apollo.query({
                query: DataServices.getList('district', {"fields" : `id district_lang(where: {lang: {_eq: "en"}}){lang name}`}),
                variables: {
                  where_key : where_1,
                  orderBy:{ordinal : 'desc'}
                }
              })
              if (data) {
                let result_1 = data[Object.keys(data)];
                if (result_1) {
                  for (let index = 0; index < result_1.length; index++) {
                    let ele1 = result_1[index];
                    optionsData.push({value: ele1.id, label: ele1.district_lang[0].name})
                  }
                }
              }
            }
          }else if(element['name']== "name_ward"){
            console.log("this.district_id",this.district_id)
            if(this.district_id){
              let where_1 = {
                deleted : {_eq : false},
                district_id : {_eq : this.district_id}
              }
              let {data} = await this.$apollo.query({
                query: DataServices.getList('ward', {"fields" : `id ward_lang(where: {lang: {_eq: "en"}}){lang name}`}),
                variables: {
                  where_key : where_1,
                  orderBy:{ordinal : 'desc'}
                }
              })
              if (data) {
                let result_1 = data[Object.keys(data)];
                if (result_1) {
                  for (let index = 0; index < result_1.length; index++) {
                    let ele1 = result_1[index];
                    optionsData.push({value: ele1.id, label: ele1.ward_lang[0].name})
                  }
                }
              }
            }
          }
          else{
            attributes.push(element.models.key.key);
            attributes.push(element.models.display_key);
            var where_ = {}
            var {data} = await this.$apollo.query({
              query: DataServices.getList(element.models.tableName, {"fields" : attributes.join(',')}),
              variables: {where_key : where_}
            })
            if (data) {
              var result = data[Object.keys(data)];
              if (result) {
                for (let index = 0; index < result.length; index++) {
                  const ele = result[index];
                  optionsData.push({value: ele[attributes[0]], label: ele[attributes[1]]})
                }
              }
            }
          }
          // console.log("optionsData",optionsData)
          this.options[element.key] = optionsData;
        }
        this.componentKey++;
      }

    },
    async onActionClicked(payload) {
      var action = payload.action
      var data = null
      if (payload.data) {
        data = payload.data
      }
      var pageTransaction = (new Date()).getTime();
      switch (action.name) {
        case 'view':
          this.dialogMode = action.name
          if (action.path !== undefined && action.path) {
            this.$router.push({ path: action.path + data.data[action.key] })
          } else  {
            this.editId = data.data[action.key]
            this.displayDialog = true
            this.editDialogKey++
          }
          break
        case 'edit':
          this.dialogMode = action.name
          if (action.path !== undefined && action.path) {
            localStorage.setItem(pageTransaction.toString(), JSON.stringify(payload.lazyParams));
            this.$router.push({ path: action.path + data.data[action.key],query: { page_transaction: pageTransaction.toString() }  })
          } else  {
            this.page_transaction = pageTransaction.toString();
            localStorage.setItem(pageTransaction.toString(), JSON.stringify(payload.lazyParams));
            this.editId = data.data[action.key]
            this.displayDialog = true
            this.editDialogKey++
          }
          break
        case 'delete':
          this.deleteId = data.data[action.key]
          this.deleteName = data.data.name
          this.dataDelete = data.data
          this.showDeleteDialog = true
          break
        case 'add':
          this.dialogMode = action.name
          if (action.path !== undefined && action.path) {
            this.$router.push({ path: action.path })
          } else  {
            this.displayDialog = true
            this.editDialogKey++
          }
          break
        case 'custom':
          await action.handler(data.data, this)
          this.componentKey++
          break
      }
    },
    async sleep(ms) {
      return new Promise((resolve) => {
        setTimeout(resolve, ms);
      });
    },
    async deleteData() {
      this.showDeleteDialog = false
      var that = this;
      //gọi kiểm tra có tồn tại trận đấu hay không
      var {data} = await this.$apollo.query({
        query: DataServices.getList('match', {"fields" : `id`}),
        variables: {
          where_key: {
            statdium_id: {'_eq': this.deleteId},
            deleted : {'_eq' : false}
          },
          offset:0,
          limit:1,
        }
      })
      var model = data[Object.keys(data)];
      if (model.length > 0) {
        alert("This stadium cannot be deleted");
        return;
      }

      var variables = {
        'data_update': {
          'deleted': true
        },
        where_key: {
          id: {'_eq': this.deleteId}
        }
      }
      await this.$apollo.mutate({
        mutation: DataServices.updateData('stadium'),
        variables: variables
      }).then(async (res) => {
        console.log(res)
        that.$commonFuction.is_loading(false);
        that.$toast.add({ severity: 'success', summary: 'Success', detail: 'Deleted success', life: 3000 })
        that.componentKey++;
      })
      // that.componentKey++;
      
    },
    
  },
  

}
</script>
<style lang="css">
.p-calendar .p-datepicker { width: 280px; padding: 0px; padding-top: 5px;}
.p-calendar .p-datepicker td, .p-calendar .p-datepicker td a {padding: 0px !important;}
.p-calendar .p-datepicker td span {padding: 0px !important; width: 30px !important; height: 30px !important;}
.p-datepicker .p-datepicker-header{padding: 5px !important;}
.p-inputwrapper-focus .p-dropdown-panel {
    top: 0px !important;
    left: 0px !important;
}
</style>